import { findElement } from 'base/tools';
import Cookies from 'js-cookie';
import Stats from 'frontend_stats';

const body = document.querySelector('body');

const COOKIE_NAME = 'listingBoxComesFrom';

const saveCookie = box => {
	if (! location) return;
	const { pathname } = location;
	Cookies.set(COOKIE_NAME, pathname);
};

export const getCookie = () => Cookies.get(COOKIE_NAME);
export const deleteCookie = () => Cookies.remove(COOKIE_NAME);

/* Make the mh.listing_box links trackable
 * so we can make use of them like opt out of
 * AB tests and so on...
*/
const listingBoxHandler = (event) => {
	const box = findElement(event.target, 'listingBox');
	if (! box) return;
	const isAnchor = box.tagName.toUpperCase() === 'A';
	if (! isAnchor) return;
	saveCookie(box);
};

const listingBoxListener = () => {
	body.addEventListener('click', listingBoxHandler, false);
};

export default listingBoxListener;
